import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class SVGLoader extends Component {

  _LOCALSTORAGE_KEY_SVG_DATA = 'azbo-svg-sprite-data';

  _LOCALSTORAGE_KEY_SVG_REVISION = 'azbo-svg-sprite-revision';

  _SVG_SPRITE_FILE = '/assets/icons/svg-sprite.svg';

  configure() {
    return super.configure();
  }

  initialize() {
    this.start();
    return super.initialize();
  }

  start() {

    if(!this.isSVGSupported()) {
      return true;
    }

    if (!this.loadFromCache()) {
      this.reload();
    }

  }

  isSVGSupported() {
    return (
      document.createElementNS
      && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect
    );
  }

  isLocalStorageAvailable() {
    return 'localStorage' in window && window['localStorage'] !== null;
  }

  isClientHasActualRevision() {
    let revision = localStorage.getItem(this._LOCALSTORAGE_KEY_SVG_REVISION);
    return (revision || '').toString() === this.revision.toString();
  }

  loadFromCache() {
    if (this.isLocalStorageAvailable() && this.isClientHasActualRevision()){
      let data = localStorage.getItem(this._LOCALSTORAGE_KEY_SVG_DATA);
      if (data) {
        this.injectData(data);
        return true;
      }
    }
    return false;
  }

  reload() {

    try {
      let request = new XMLHttpRequest();
      request.open('GET', this._SVG_SPRITE_FILE, true);
      request.onload = () => {
        if (request.status >= 200 && request.status < 400){
          let data = request.responseText;
          this.update(data);
        }
      };
      request.send();
    } catch(exception){
      this.logger('Can\'t load svg sprite:', exception);
    }

  }

  update(data) {

    this.injectData(data);

    if (this.isLocalStorageAvailable()) {
      localStorage.setItem(this._LOCALSTORAGE_KEY_SVG_DATA,     data);
      localStorage.setItem(this._LOCALSTORAGE_KEY_SVG_REVISION, this.revision);
    }

  }

  injectData(data) {
    if (document.body) {
      this.insertHtml(data);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        this.insertHtml(data);
      });
    }
  };

  insertHtml(data){
    document.body.insertAdjacentHTML('afterbegin', data);
  };

  get revision(){
    return (window.SVG_SPRITE_REVISION || '');
  }

}